/*
 * discover-lx1-sticky-bar.js — the "Talk to us" call button in sections/discover-lx1-sticky-bar.liquid.
 * Styles: assets/discover-lx1-sticky-bar.css. Depends on the storewide Zendesk messenger (window.zE); does
 * nothing if it has not loaded. The Zendesk voice line id comes from the section setting (data-zendesk-voice-id).
 * The bar's show-on-scroll behaviour is Instant's scroll trigger (instant-core, or assets/discover-lx1-runtime.js).
 * Moved from an inline <script> on the Instant page.
 */
(function () {
  var btn = document.getElementById('call-support-dis-sticky');
  if (!btn) return;
  btn.addEventListener('click', function () {
    if (typeof zE === 'undefined') return;
    try {
      zE('messenger:open', 'voice', btn.getAttribute('data-zendesk-voice-id') || '10e9c0e3aca22e6926b98f06b457f2fb');
    } catch (e) {}
  });
})();
